const NAME = "USER_MENUS";

export default NAME;
